import consolv from 'lib/consolv';

/**
 *  Allows configurable ad slot refreshes
 *  @param {MCPInstance} MCP
 */

export default function manualRefresh(MCP) {
  /* eslint-disable-next-line no-param-reassign */
  MCP.manualRefresh = (slots) => {
    if (!MCP.isReady) return;

    let selectedSlots;
    if (slots && Array.isArray(slots)) {
      selectedSlots = slots
        .map(element => MCP.slots.get(element))
        .filter(slot => !!slot);
    } else {
      selectedSlots = Array.from(MCP.slots.values());
    }
    consolv.log('MCP: Manual refresh triggered');

    const refreshedSlots = [];

    selectedSlots.forEach((slot) => {
      if (slot.enabled === false) return;
      if (!slot.getMetaData || slot.getMetaData('allowManualRefresh') !== true) return;

      const limit = slot.getMetaData('manualRefreshLimit');

      const currentRefreshes = slot.getMetaData('manualRefreshCount') || 0;
      const refreshType = slot.getMetaData('manualRefreshType') || 'tick';

      if (limit >= 0 && currentRefreshes >= limit) return;
      refreshedSlots.push(slot);

      slot.setMetaData('manualRefreshCount', currentRefreshes + 1);
      if (refreshType === 'immediate') {
        MCP.refreshSlot(slot.element);
      } else {
        slot.setMetaData('forceRefresh', true);
      }
    });

    consolv.log('MCP: Manual refresh slots', refreshedSlots);
  };

  // Retains compatibility with old functionality
  /* eslint-disable-next-line no-param-reassign */
  MCP.limitedRefresh = MCP.manualRefresh;
}
